import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-group-detail",
  templateUrl: "./group-detail.component.html",
  styleUrls: ["./group-detail.component.scss"],
})
export class GroupDetailComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
